// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6bf55ce5dc--wrapper--SI7e7"};